







































































  import { Component, Vue, Prop } from "vue-property-decorator";
  import axios from 'axios';
  import { General } from '@/services/General';
  import { saveAs } from 'file-saver';
  import { PlanAttachment } from "@/entity/Ppe/PlanAttachment";
  import { i18n } from "@/i18n/i18n-setup";

  @Component
  export default class PlanAttachmentsDetail extends Vue {
    @Prop({ type: String, required: false })
    planHeaderId;
    @Prop({required: true})
    attachments: Array<PlanAttachment>;
    @Prop({required: true})    
    editable: boolean;

    fileName: string = "";
    uploadPerc: number = 0;
    idSession: string = "";
    attachmentsUploaded : Array<PlanAttachment> = [];
    noteFileToUpload: string = "";
    singleFile: PlanAttachment = new PlanAttachment();

    mounted(){
      this.attachmentsUploaded = this.attachments;
    }

    async downloadAttachmentDo(attachment: PlanAttachment){
      if(attachment.id != undefined && attachment.id)
        await this.downloadAttachmentById(attachment);
      else
        await this.downloadDocumentGenericByIdSession(attachment);
    }

    async downloadDocumentGenericByIdSession(attachment: PlanAttachment){
      try {
        let response = await axios({
            method: 'get',
            url: General.GetApiUrl("/api/document/DownloadDocumentGenericByIdSession?idSession=" + attachment.sessionId),
            withCredentials: true,
            responseType: 'blob'
        });
        saveAs(new Blob([response.data]), attachment.fileName);
      } catch (error) {
          General.showAlertDanger(i18n.t("GENERIC.DOWNLOAD_FILE_ERROR") as string, this);                          
      }
    }

    async downloadAttachmentById(attachment: PlanAttachment){
      try {
          let response = await axios({
              method: 'get',
              url: General.GetApiUrl("/api/ppe/DownloadPlanAttachment?attachmentId=" + attachment.id),
              withCredentials: true,
              responseType: 'blob'
          });
          saveAs(new Blob([response.data]), attachment.fileName);
      } catch (error) {
        General.showAlertDanger(i18n.t("GENERIC.DOWNLOAD_FILE_ERROR") as string, this);                            
      }
    }

    showSuccessAlert(sessionId: any) {
      this.idSession = sessionId;
      this.uploadPerc = 100;
    }

    confirmAttachment() {
      if(!this.isAlreadyUploaded(this.fileName)) {
        if(this.idSession != undefined && this.idSession !== "") {
          let newAttachment = new PlanAttachment();
          newAttachment.fileName = this.fileName;
          newAttachment.sessionId = this.idSession
          newAttachment.notes = this.noteFileToUpload;
          newAttachment.idHeader = this.planHeaderId;
          newAttachment.toDelete = false;

          this.singleFile = newAttachment;
          this.attachmentsUploaded.push(this.singleFile);

          this.noteFileToUpload = null;  
          this.singleFile = new PlanAttachment();

          this.$bvModal.hide('add-file-modal'); 
        } else {
          General.showAlertDanger(i18n.t("GENERIC.FILE_BROWSE_MANDATORY") as string, this);
        }
      } else {
        General.showAlertDanger(i18n.t("GENERIC.FILE_ALREADY_UPLOADED") as string, this);
      }
    }

    isAlreadyUploaded(fileName: string) {
      let check = false;
      if((this.attachmentsUploaded.length > 0 && this.attachmentsUploaded.findIndex(f => f.fileName === fileName && !f.toDelete) >=  0))
          check = true;
      return check;
    }

    removeAttachment(attachment:PlanAttachment, index: number){
      General.confirm(
        i18n.t("GENERIC.CONFIRM_DELETE_ATTACHMENT") as string,
        this,
        async () => {
          attachment.toDelete = true;
          Vue.set(this.attachmentsUploaded, index, attachment) 
        }  
      );  
    }

    updateProgress(e: any) {
      this.uploadPerc = e;
    }

    getFileName(fileName: string) {
      this.fileName = fileName;
    }

    reset() {
      this.uploadPerc = 0;
      this.fileName = "";
      this.idSession = "";
    }
}
